// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"236":"d015d9dd234398f8","888":"b6853f0190ea9f57"}[chunkId] + ".css";
};